export const NEWSLETTER_HISTORY_STATUSES = ["scheduled", "sent", "some_failed", "all_failed"];

export const NEWSLETTER_HISTORY_STATUS_META = {
  scheduled: { label: "Programmata", color: "#0b3d87", bg: "#eef2ff" },
  sent: { label: "Inviata", color: "#166534", bg: "#ecfdf5" },
  some_failed: { label: "Parziale", color: "#c2410c", bg: "#fff7ed" },
  all_failed: { label: "Fallita", color: "#b91c1c", bg: "#fef2f2" },
};

export const NEWSLETTER_HISTORY_STATUS_FILTER_OPTIONS = NEWSLETTER_HISTORY_STATUSES.map((value) => ({
  value,
  label: NEWSLETTER_HISTORY_STATUS_META[value].label,
}));

export const getNewsletterHistoryStatusMeta = (status) =>
  NEWSLETTER_HISTORY_STATUS_META[status] || {
    label: status || "Sconosciuto",
    color: "#475569",
    bg: "#f1f5f9",
  };
